import React, { useEffect } from 'react';
import Page from '../../containers/Page';
import ListSection from './ListSection';
import FloatingActionBtn from '../Buttons/FloatingActionBtn';
import { Link } from 'react-router-dom';

function List({ list, sortList, handleCheckboxChange, setHeaderTitle, isListEmpty }) {
	useEffect(
		() => {
			setHeaderTitle('Ma liste');
		},
		[ setHeaderTitle ]
	);

	return (
		<Page>
			{!isListEmpty() ? (
				<div>
					<ListSection
						type="roomtemp"
						list={sortList(list.roomtemp)}
						handleCheckboxChange={handleCheckboxChange}
						edit={false}
					/>
					<ListSection
						type="fridge"
						list={sortList(list.fridge)}
						handleCheckboxChange={handleCheckboxChange}
						edit={false}
					/>
					<ListSection
						type="freezer"
						list={sortList(list.freezer)}
						handleCheckboxChange={handleCheckboxChange}
						edit={false}
					/>
				</div>
			) : (
				<div className="emptyList">
					<p className="emptyList__p">Votre liste est vide. Ajoutez-y des produits!</p>
					<Link to="/lists/new">
						<button className="emptyList__actionBtn">Ajouter un produit</button>
					</Link>
				</div>
			)}

			<FloatingActionBtn path={'/lists'} image={'create'} />
		</Page>
	);
}

export default List;
